const LOGO_IMAGE_MIMES = new Set(['image/jpeg', 'image/png', 'image/webp']);
export const CX_EMAIL_LOGO_ACCEPT = 'image/jpeg,image/png,image/webp';
const MAX_BYTES = 10 * 1024 * 1024;

/**
 * Valida imagem de logo CX sem redimensionar — apenas tipo e tamanho (máx. 10 MB).
 */
export function validateCxEmailLogoFile(file) {
  if (!file || !(file instanceof Blob)) {
    throw new Error('Selecione uma imagem.');
  }
  if (!LOGO_IMAGE_MIMES.has(file.type)) {
    throw new Error('Formato não permitido. Use JPEG, PNG ou WebP.');
  }
  if (file.size > MAX_BYTES) {
    throw new Error('Imagem muito grande. Máximo 10 MB.');
  }
  return file;
}
